<template>
  <div class="bill">
    <!-- 账单 -->
    <div class="billtop">
      <span>{{$t('fangTXQ_bill')}}</span>
      <span v-if="isJingJiang && jjAccountAdjust" @click="goInsertBill" class="ext-btn">{{ $t('JJ_AccountIn_title') }}</span>
    </div>
    <div class="billContent">
      <ul class="billList clearfix">
        <!-- 余额 -->
        <li>{{$t('fangTXQ_masterBase')}}:
          <span>{{(orderInfo.fMasterDto.masterBase.charge-orderInfo.fMasterDto.masterBase.pay).toFixed(2)}}</span>
        </li>
        <!-- 信用 -->
        <li>{{$t('fangTXQ_credit')}}:
          <span>{{orderInfo.fMasterDto.masterBase.credit.toFixed(2)}}</span>
        </li>
        <!-- 余额合计 -->
        <li>{{$t('fangTXQ_othBalance')}}:
          <span>{{orderInfo.othBalance.toFixed(2)}}</span>
        </li>
        <!-- 信用合计 -->
        <li>{{$t('fangTXQ_othCredit')}}:
          <span>{{orderInfo.othCredit.toFixed(2)}}</span>
        </li>
        <!-- 结账提醒 -->
        <li v-if="orderInfo.fMasterDto.masterBase.coMsg"
            style="width:100%;height:auto;">
          {{$t('fangTXQ_coMsg')}}：<span style="color:red">{{orderInfo.fMasterDto.masterBase.coMsg}}</span>
        </li>
      </ul>
      <table class="itemsList">
        <tr class="category">
          <th width="36px">
            <!-- 房号 -->
            <span> {{$t('fangTXQ_rmno')}}</span>
          </th>
          <!-- 项目 -->
          <th width="108px">
            <span> {{$t('fangTXQ_project')}}</span>
          </th>
          <!-- 时间 -->
          <th width="64px">
            <span>{{$t('fangTXQ_time')}}</span>
          </th>
          <!-- 操作员 -->
          <th width="68px">
            <span>{{$t('fangTXQ_operator')}}</span>
          </th>
          <!-- 金额 -->
          <th width="50px">
            <span>{{$t('fangTXQ_amount')}}</span>
          </th>
        </tr>
        <tr class="item"
            v-for="(val,key) in orderInfo.acclist"
            :key="key">
          <td>{{val.rmno}}</td>
          <td>{{val.taDescript}}</td>
          <td>
            <p class="small">{{val.genDate | dateD}}</p>
          </td>
          <td>{{val.createUser}}</td>
          <td>{{ val.arrangeCode.indexOf('9') == 0 ? val.pay : val.charge}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isJingJiang: localStorage.getItem('isJingJiang') == 'yes',
        jjAccountAdjust: localStorage.getItem('jjAccountAdjust') == 'yes',
      }
    },
    props: {
      orderInfo: {
        type: Object,
        default: {}
      }
    },
    filters: {
      dateD(value) {
        return value != "" ? value.replace(/-/g, "/").substring(5, 16) : "";
      }
    },
    methods: {
      goInsertBill(){
        this.$emit('goInsertBill')
      }
    }
  };
</script>

<style lang='less'>
  .bill {
    box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    margin-top: 10px;
    background-color: #fff;
    clear: both;

    .billtop {
      text-align: center;
      font-size: 12px;
      font-weight: 600;
      line-height: 40px;
      height: 40px;
      box-sizing: border-box;
      border-bottom: 1px dashed #ddd;
      position: relative;
      .ext-btn {
        position: absolute;
        right: 15px;
        color: orange;
      }
    }

    .billContent {
      padding: 0 10px 10px;

      .billList {
        padding: 18px 3px;

        li {
          float: left;
          width: 50%;
          box-sizing: border-box;
          height: 25px;
          line-height: 25px;
          font-size: 12px;

          span {
            margin-left: 5px;
          }
        }
      }

      .itemsList {
        width: 100%;

        .category {
          background-color: #a4a4a4;
          height: 39px;
          color: #fff;

          th {
            span {
              width: 100%;
              display: block;
              border-right: 1px solid rgba(255, 255, 255, 0.3);
            }
          }
        }

        .item {
          height: 41px;

          td {
            text-align: center;
          }

          .small {
            transform-origin: center;
            transform: scale(0.83);
          }

          &:nth-of-type(2n) {
            background-color: #f5f5f5;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// bill.vue?5b87ec82